import { set, get, observable, makeObservable, action, computed } from 'mobx';

const isNil = (o: any) => o === undefined || o === null;

/**
 * @hideconstructor
 * @internal
 * @hidden
 */
export class Bucket {
  constructor() {
    makeObservable(this);
  }

  @observable
  private v: any = undefined;

  @observable.shallow
  public target: any = undefined;

  @observable
  public key: string = undefined;

  @observable
  public sub: string = undefined;

  private __setter__() {
    return isNil(this.sub) //
      ? set(this.target, this.key, this.v) //
      : set(this.target, this.key, { [this.sub]: this.v });
  }

  private __getter__() {
    return isNil(this.sub) //
      ? get(this.target, this.key) //
      : get(get(this.target, this.key), this.sub);
  }

  @computed
  get value() {
    if (this.target) {
      if (isNil(get(this.target, this.key)) || (isNil(this.__getter__()) && !isNil(this.v))) {
        this.__setter__();
      }
      return this.__getter__();
    }
    // DEFAULT
    return this.v;
  }

  set value(value: any) {
    if (this.target) {
      if (isNil(this.sub)) {
        set(this.target, this.key, value);
        return;
      }

      if (isNil(get(this.target, this.key))) {
        set(this.target, this.key, {});
      }

      set(get(this.target, this.key), this.sub, value);
      return;
    }
    // DEFAULT
    this.v = value;
  }

  @action
  link(target: object, key: string, sub?: string) {
    this.target = target;
    this.key = key;
    this.sub = sub;
  }
}
